import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

export default class NewProducts extends React.Component {
  render() {
    return (
      <div className={` ${"newProducts"}`}>
        <div className={"titles"}>
          <span>محصولات جدید</span>
        </div>
        <div>
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            spaceBetween={16}
            loop={true}
            slidesPerView={2}
            slidesPerGroup={3}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            className={`${"slider"} ${"newProductsSlider"}`}
          >
            {this.props.data.map((product, index) => (
              <SwiperSlide key={index} className={"newProductsSwipper"}>
                <Link
                  href={`/product/${product.slug}`}
                  style={{ width: "100%" }}
                >
                  <div className={"newProductCard"}>
                    <img src={product.pic} />
                    <div className={"details"}>
                      <span className={"name"}>{product.name}</span>
                      <span className={"price"}>
                        {(+product.min_price)?.toLocaleString()}{" "}
                        <span className={"toman"}>تومان</span>
                      </span>
                    </div>
                  </div>
                </Link>{" "}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  }
}
